<template>
  <div class="CustomerList">
    <!-- <div
      class="item acea-row row-between-wrapper"
      v-for="item in list"
      :key="item.id"
      @click="toChat"
    >
      <div class="pictrue"><img :src="item.avatar" /></div>
      <div class="text line1">{{ item.nickname }}</div>
      916586880
      3566987374
    </div> -->
    <a
      class="service-item item acea-row row-between-wrapper"
      href="http://wpa.qq.com/msgrd?v=3&uin=2081663219&site=qq&menu=yes"
      target="_blank"
    >
      <div class="avatar">
        <img src="@/assets/moblie/images/before-service.jpg" />
      </div>
      <div class="text line1">客服一</div>
    </a>
    <a
      class="service-item item acea-row row-between-wrapper"
      href="http://wpa.qq.com/msgrd?v=3&uin=1171363534&site=qq&menu=yes"
      target="_blank"
    >
      <div class="avatar">
        <img src="@/assets/moblie/images/before-service.jpg" />
      </div>
      <div class="text line1">客服二</div>
    </a>
  </div>
</template>
<script>
import { serviceList } from "@api/user";

export default {
  name: "CustomerList",
  data() {
    return {
      list: [],
      productId: 0,
      orderId: ""
    };
  },
  watch: {
    $route(n) {
      if (n.name === "CustomerList") {
        if (n.params.productId) this.productId = n.params.productId;
        else this.productId = 0;

        if (n.query.orderId) this.orderId = n.query.orderId;
        else this.orderId = "";
      }
    }
  },
  methods: {
    getList() {
      serviceList().then(res => {
        this.list = res.data;
      });
    },
    toChat(qq) {
      window.location.href = `http://wpa.qq.com/msgrd?v=3&uin=${qq}&site=qq&menu=yes`;
      //https://wpa1.qq.com/kHYHvUz1?_type=wpa&qidian=true
      //http://wpa.qq.com/msgrd?v=3&uin=${qq}&Site=qq&Menu=yes
      //mqqwpa://im/chat?chat_type=wpa&uin=你的QQ号&version=1&src_type=web
    }
  },
  mounted() {
    this.getList();
    if (this.$route.params.productId)
      this.productId = this.$route.params.productId;
    if (this.$route.query.orderId) this.orderId = this.$route.query.orderId;
  }
};
</script>
<style scoped>
.CustomerList {
  margin-top: 0.13rem;
}
.CustomerList .item {
  height: 1.38rem;
  border-bottom: 1px solid #eee;
  padding: 0 0.24rem;
  background-color: #fff;
}
.CustomerList .item .pictrue {
  width: 0.9rem;
  height: 0.9rem;
  border-radius: 50%;
  border: 0.03rem solid #fff;
  box-shadow: 0 0 0.1rem 0.05rem #f3f3f3;
  -webkit-box-shadow: 0 0 0.1rem 0.05rem #f3f3f3;
  -moz-box-shadow: 0 0 0.1rem 0.05rem #f3f3f3;
}
.CustomerList .item .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.CustomerList .item .text {
  width: 5.82rem;
  font-size: 0.32rem;
  color: #000;
}

/* .service-item {
} */
.service-item .avatar img {
  width: 0.6rem;
  height: 0.6rem;
}
</style>
